module.exports = __webpack_public_path__ + "img/RECREATION_YOURFEELING.27742e45.jpg";